import type { AxiosResponse } from 'axios';
import routes from '@/config/routes';
import { v3Get, v3Post, v3Remove } from '@/api/axios.instance.V3';
import type { IClientPermissionRequest, IPermissionGroup } from '@/store/admin/types/types';
import type { ApiResponse } from '../types';

const getPermissionGroup = (clientId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.permissionAdmin.getPermissionGroup}/client/${clientId}/list`);

const getPermissionGroupByClientAndPermissionId = (request: IClientPermissionRequest): ApiResponse =>
  v3Get(
    `${routes.backendUrl.permissionAdmin.permission}/group/client/${request.clientId}/permission/${request.permissionId}/list`,
  );

const savePermissionGroup = async (permissionGroup: IPermissionGroup): Promise<AxiosResponse> => {
  return await v3Post(`${routes.backendUrl.permissionAdmin.permission}/group/create`, permissionGroup);
};

const deletePermissionGroup = async (permissionGroup: IPermissionGroup): Promise<AxiosResponse> => {
  const { clientId, groupId, groupLabel } = permissionGroup;
  return await v3Remove(
    `${routes.backendUrl.permissionAdmin.permission}/group/delete/client/${clientId}/${groupId}/${groupLabel}`,
  );
};

export const permissionGroupAdminApi = {
  getPermissionGroup,
  getPermissionGroupByClientAndPermissionId,
  savePermissionGroup,
  deletePermissionGroup,
};
